// Uses static redirect defined via Netlify `_redirects` file

export const getAffiliateUrl = (firmId: string): string => {
  return `/go/${firmId}`;
};
